// src/components/Common-components/NavigatorBar/navBar.js
import React from 'react';
import '../../../css/NavigatorBar/navBar.css';

function Navbar({ navItems, onNavClick, activeIndex }) {
  const [isCompact, setIsCompact] = React.useState(false);

  React.useEffect(() => {
    // 뷰포트 폭에 따라 단일 버튼(콤팩트) 또는 전체 탭 목록을 전환한다.
    const onResize = () => {
      setIsCompact(window.innerWidth <= 1327);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <nav className="tab-nav">
      {navItems.map((item, idx) =>
        isCompact
          ? (activeIndex === idx && (
              <button
                key={item.id}
                className="tab-nav-btn target"
                onClick={() => onNavClick(idx)}
              >
                {item.label}
              </button>
            ))
          : (
              <button
                key={item.id}
                className={`tab-nav-btn${activeIndex === idx ? ' target' : ''}`}
                onClick={() => onNavClick(idx)}
              >
                {item.label}
              </button>
            )
      )}
    </nav>
  );
}

export default Navbar;
